import React, { useEffect, useRef, useState } from 'react';
import './loader.scss'; // Add your loader styles here
import lottie from 'lottie-web';

const Loader = () => {
  const [motionData, setMotionData] = useState(null);
  const motionContainer = useRef(null);

  useEffect(() => {
    import('../../Assets/images/json/loading_dots.json').then(
      ({ default: data }) => {
        setMotionData(data);
      },
    );
  }, []);

  useEffect(() => {
    if (motionData) {
      lottie.loadAnimation({
        container: motionContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        motionData,
      });
    }
  }, [motionData]);

  return <div className="loader" ref={motionContainer}></div>;
};

export default Loader;
